import { API } from '@apis'
import { KEY_ACCESS, KEY_REFRESH } from '@constants'
import { getLocalStorage, setLocalStorage } from '@helpers'
import axios, { Method } from 'axios'

import axiosService from './axiosService'
import { CLIENT_ID, CONFIG, ERROR_400, SECRET, redirectToLogin } from './utils'

type GetRefreshTokenParam = {
  method: Method
  apiPath: string
  params: any
  listApi: any
  data: any
}
type GetRefreshToken = Partial<GetRefreshTokenParam> | undefined

export default async function getRefreshToken({ method, apiPath, params, listApi, data }: GetRefreshToken) {
  const refresh_token = getLocalStorage(KEY_REFRESH)

  if (!refresh_token) {
    redirectToLogin()
    return
  }

  const url = import.meta.env.VITE_BASE_API_URL + API.REFRESH_TOKEN

  const payload = {
    client_id: CLIENT_ID,
    client_secret: SECRET,
    refresh_token,
  }

  try {
    const response = await axios.post(url, payload, CONFIG)

    if (response.status !== 200) {
      console.error('ERROR REFRESH TOKEN', response)
      return
    }

    setLocalStorage(KEY_ACCESS, response.data.access_token)
    setLocalStorage(KEY_REFRESH, response.data.refresh_token)

    if (method && apiPath) {
      return axiosService({ method, apiPath, params, data })
    } else if (listApi) {
      listApi()
    }

    return
  } catch (error) {
    const isError = error?.response?.status === 400
    const isInvalidGrant = error.response.data.error === ERROR_400
    const isRedirect = isError && isInvalidGrant

    return isRedirect ? redirectToLogin() : setTimeout(() => getRefreshToken({ method, apiPath, params, data }), 3000)
  }
}
